export default () => jQuery(($) => {
    let remove_link_id = "add_more_item_remove";
    let remove_html = '<a id="' + remove_link_id + '" href >Remove</a>';

    let maybeDisableButton = (field_name) => {
        let max_items = $('[data-add-more-' + field_name + '-current-index]').attr('data-add-more-limit');
        if(max_items){
            let count = $("[data-add-more-id='" + field_name + "_add_more_container']").length;
            //console.log({numItems: count, maxItems: max_items});
            let max_reached = count >= max_items;
            let button = $("a[id='"+field_name+"_add_more_button']");
            max_reached ? button.hide() : button.show();
        }

    }

    $('a[id$="add_more_button"]').each(function(index){
        maybeDisableButton($(this).attr('id').replace('_add_more_button', ''));

    })

    $(document).on('click', "a[id^='" + remove_link_id + "']", function (event) {
            event.preventDefault();
            let field_name = $(this).parent().attr('data-add-more-id').replace('_add_more_container', '');
            //console.log(field_name, 'in remove');
            $(this).parent().remove();
            maybeDisableButton(field_name);
        }
    );

    $(document).on('click', "a[id$='_add_more_button']", function (event) {
        event.preventDefault();
        let button = $(this);
        let add_more_field_name = button.attr('id').replace('_add_more_button', '');
        let add_more_container = button.attr('id').replace('_add_more_button', '_add_more_container');
        let fieldset_selector = $("[data-add-more-id='" + add_more_container + "']").last();
        let lastElement = $(fieldset_selector);
        let newElement = $(lastElement).clone();
        let nextIdx = parseInt($('[data-add-more-' + add_more_field_name + '-current-index]').attr('data-add-more-' + add_more_field_name + '-current-index'));
        newElement.find(".duet-date").remove();
        newElement.find("a[id^='" + remove_link_id + "']").remove(); // Remove if already there since it's added later because the first one doesn't have a remove button.
        newElement.find('input, select, duet-date-picker, label, radio').each(function () {
            if ($(this).attr('type') === 'checkbox' || $(this).attr('type') === 'radio') {
                $(this).prop('checked', false);
            } else {
                $(this).val("");
            }
            if ($(this).attr('name') !== undefined) {
                $(this).attr('name', $(this).attr('name').replace(/\[(\d+)]/, '[' + (nextIdx) + ']'));
            }
            if ($(this).attr('id') !== undefined) {
                $(this).attr('id', $(this).attr('id').replace(/\[(\d+)]/, '[' + (nextIdx) + ']'));
            }
            if ($(this).attr('identifier') !== undefined) {
                $(this).attr('identifier', $(this).attr('identifier').replace(/\[(\d+)]/, '[' + (nextIdx) + ']'));
            }
            if ($(this).attr('for') !== undefined) {
                $(this).attr('for', $(this).attr('for').replace(/\[(\d+)]/, '[' + (nextIdx) + ']'));
            }
        });
        // Update the index for the add more field
        $('[data-add-more-' + add_more_field_name + '-current-index]').attr('data-add-more-' + add_more_field_name + '-current-index', nextIdx + 1)
        newElement.find('hr').before($(remove_html).attr("id", remove_link_id));
        lastElement.after(newElement);
        maybeDisableButton(add_more_field_name);
    })
});
